export const getBounds = (nodeViews) => {
    let minX = Number.POSITIVE_INFINITY;
    let minY = Number.POSITIVE_INFINITY;
    let maxX = Number.NEGATIVE_INFINITY;
    let maxY = Number.NEGATIVE_INFINITY;
    let idx = nodeViews.length;
    while (idx--) {
        const nv = nodeViews[idx];
        const x = nv.position[0];
        const y = nv.position[1];
        if (x <= minX) {
            minX = x;
        }
        if (y <= minY) {
            minY = y;
        }
        if (x >= maxX) {
            maxX = x;
        }
        if (y >= maxY) {
            maxY = y;
        }
    }
    const newBounds = {
        minX,
        minY,
        maxX,
        maxY
    };
    return newBounds;
};
